export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant02-mobile-de.24c9e00d.png";